module.exports = [{"rank":"admin","name":"Admin"},{"rank":"editor","name":"Editor"},{"rank":"librarian","name":"Librarian"},{"rank":"proofer","name":"Proofer"},{"rank":"narrator","name":"Narrator"}]


//////////////////
// WEBPACK FOOTER
// ./static/roles.json
// module id = 266
// module chunks = 6